import React from "react";
import useUploadFiles from "../../../services/hooks/useUploadFiles";

// components

import Upload from "../../../component/modals/upload";
import TextInput from "../../../component/element/forms/TextInput";
import SelectDate from "../../../component/element/forms/SelectDate";
import Modal from "../../../component/ui/modal";
// import DateInput from "../../../component/element/forms/DateInput";

// state
import { useAppDispatch, useAppSelector } from "../../../store";
import {
  ICompanyDocument,
  ICompanyDocumentError,
} from "../../../store/types/company";
import { create_company_docs } from "../../../services/apis/company";
import { useParams } from "react-router-dom";

type IUploadDocument = {
  visible: boolean;
  onHandler: () => void;
};

const UploadDocument: React.FC<IUploadDocument> = ({ visible, onHandler }) => {
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const loading = useAppSelector((state) => state.company.loading);
  const { loader, uploadFile, deleteFiles } = useUploadFiles();
  const [data, dataSet] = React.useState<ICompanyDocument>({
    name: "",
    company_id: "",
    issuing_body: "",
    expiring_date: "",
    issuing_date: "",
    path: "",
  });
  const [error, errorSet] = React.useState<ICompanyDocumentError>({
    company_id: "",
    expiring_date: "",
    issuing_body: "",
    issuing_date: "",
    name: "",
    path: "",
  });

  const handleOk = () => {
    let err = false;
    if (!data.company_id) {
      err = true;
      errorSet((prev) => ({ ...prev, company_id: "" }));
    }
    if (!data.name) {
      err = true;
      errorSet((prev) => ({ ...prev, name: "" }));
    }
    if (!data.expiring_date) {
      err = true;
      errorSet((prev) => ({ ...prev, expiring_date: "" }));
    }
    if (!data.issuing_body) {
      err = true;
      errorSet((prev) => ({ ...prev, issuing_body: "" }));
    }
    if (!data.issuing_date) {
      err = true;
      errorSet((prev) => ({ ...prev, issuing_date: "" }));
    }
    if (!data.path) {
      err = true;
      errorSet((prev) => ({ ...prev, path: "" }));
    }
    console.log(error);
    if (err) return;
    create_company_docs(data, dispatch);
    onHandler?.();
  };

  const onChangeText = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value, name } = e.target;
    dataSet((prev) => ({ ...prev, [name]: value }));
    errorSet((prev) => ({ ...prev, [name]: "" }));
  };

  const onLoad = React.useCallback(() => {
    if (id) dataSet((prev) => ({ ...prev, company_id: id }));
  }, [id]);

  React.useEffect(() => {
    onLoad();
  }, [onLoad]);

  return (
    <Modal
      title="Upload Document"
      open={visible}
      onClose={onHandler}
      onOkClick={handleOk}
      variant="medium"
      isLoading={loading}
    >
      <div className="w-full ">
        <div className="">
          <Upload
            label="PDF"
            title="Upload Company Document"
            name="documents"
            loading={loader}
            status={error.path}
            completed={data.path ? true : false}
            onChange={async (fileOrFiles) => {
              const paths = await uploadFile(fileOrFiles as File, "documents");
              if (paths.length > 0) {
                const file_path = paths[0]?.base_url + "/" + paths[0]?.path;
                // const file_path = paths[0]?.path;
                dataSet((prev) => ({ ...prev, path: file_path }));
                errorSet((prev) => ({ ...prev, path: "" }));
              }
            }}
            onDelete={async () => {
              if (data.path) {
                const res = await deleteFiles(data.path);
                if (res) {
                  dataSet((prev) => ({ ...prev, path: "" }));
                  errorSet((prev) => ({ ...prev, path: "" }));
                }
              }
            }}
          />
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mt-3">
        <TextInput
          label="Document Name"
          name="name"
          onChange={onChangeText}
          placeholder="Document Name"
          type="text"
          value={data.name}
          status={error.name}
        />

        <TextInput
          label="Issuing Body"
          name="issuing_body"
          onChange={onChangeText}
          placeholder="Issuing Body"
          type="text"
          value={data.issuing_body}
          status={error.issuing_body}
        />

        {/* <DateInput
            label="Issuing Date"
            onChange={(res) => {
              dataSet((prev) => ({ ...prev, issuing_date: res }));
              errorSet((prev) => ({ ...prev, issuing_date: "" }));
            }}
            error={error.issuing_date}
          /> */}

        {/* <DateInput
            label="Expiring Date"
            onChange={(res) => {
              dataSet((prev) => ({ ...prev, expiring_date: res }));
              errorSet((prev) => ({ ...prev, expiring_date: "" }));
            }}
            error={error.expiring_date}
          /> */}

        <SelectDate
          label="Issuing Date"
          onChange={(res) =>
            dataSet((prev) => ({ ...prev, issuing_date: res }))
          }
          placeholder="Issuing Date"
        />

        <SelectDate
          label="Expiring Date"
          onChange={(res) =>
            dataSet((prev) => ({ ...prev, expiring_date: res }))
          }
          placeholder="Expriring Date"
        />
      </div>
    </Modal>
  );
};

export default UploadDocument;
